import { Box, Button, Group, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import { repositoryDelivery } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";

const CancelAssignmentView = ({ idItems, onClose }: DeleteProduct) => {
  const handleDelete = async () => {
    const res = await repositoryDelivery.post<MessageResponse<boolean>>(
      `/api/v1/TblDeliveryAssignment/delete`,
      idItems
    );
    if (res)
      if (res.success) {
        NotificationExtension.Success("Hủy giao nhận thành công !");
        setTimeout(() => {
          onClose((prev: any) => !prev);
          modals.closeAll();
        }, 300);
      }
  };

  return (
    <Box size={"auto"}>
      <Text size="20px" mt={5}>
        Bạn có chắc chắn muốn hủy phân công đã chọn ?
      </Text>
      <Group justify="center" mt="lg">
        <Button
          type="button"
          color="blue"
          onClick={handleDelete}
          leftSection={<IconCheck size={18} />}
        >
          Có
        </Button>
        <Button
          type="button"
          color="gray"
          onClick={() => modals.closeAll()}
          leftSection={<IconX size={18} />}
        >
          Không
        </Button>
      </Group>
    </Box>
  );
};

type DeleteProduct = {
  idItems: (number | string)[];
  onClose: any;
};

export default CancelAssignmentView;
